import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QuestionPrompt from '../QuestionPrompt';
import DialogPrompt from '../DialogPrompt';
import BadgeCollect from '../../badges/BadgeCollect';
import Button from '../../../buttons/Button';//eslint-disable-line import/no-named-as-default
import MultipleAnswerOptionReview from './MultipleAnswerOptionReview'; //eslint-disable-line import/no-named-as-default
import MultipleAnswerFeedbackReview from './MultipleAnswerFeedbackReview'; //eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as indicatorHelper from '../../../../helpers/indicatorHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as userDataHelper from '../../../../helpers/userDataHelper';

class MultipleAnswerReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
            locale: appHelper.getLocalData(this.props.screenObject),
            outcomeLocale: {},
            questionChecked: false,
            correctAnswerCount: appHelper.getTypeCount(this.props.screenObject.options, "result", "best").length,
            responseData: this.props.responseData,
            showOptions: true,
            showCheckBtn: false,
            showFeedback: true,
            checkAnswers: true,
            //badges
            badgesEarned:[],
            checkBadgesEarned: false,
            collected: true,
            character_name: appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            allowAudioAutoPlay: false,
            animatePrompt: false,
        };
        this.randomiseOptions = this.randomiseOptions.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.checkAnswers = this.checkAnswers.bind(this);
        this.showFeedback = this.showFeedback.bind(this);
        this.reattempt = this.reattempt.bind(this);
        //badges
        this.checkBadgeEarnedOnObject = this.checkBadgeEarnedOnObject.bind(this);
        this.getBadge = this.getBadge.bind(this);
    }

    componentDidMount() {
        this.checkAnswers();
        this.checkBadgeEarnedOnObject();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkBadgesEarned: true
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject)
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkAnswers) {
            this.checkAnswers();
        }

        if(this.checkBadgesEarned){
            this.checkBadgeEarnedOnObject();
        }
    }

    checkBadgeEarnedOnObject(){
        let params = {
            bite_id: this.state.responseData.bite_id,
            asset_id: this.state.screenObject.asset_id
        };

        let badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
        this.setState({
            checkBadgesEarned: false,
            badgesEarned: Object.assign([],badgesEarned)
        });
    }

    getBadge(badge_id){
        //return appHelper.getArrayObjectByKey(localStorage.achievements, "code", code);
    }

    randomiseOptions() {
        this.setState({
            screenObject: Object.assign({}, this.state.screenObject, {
                options: dataHelper.randomiseArray(this.state.screenObject.options)
            })
        });
    }

    renderOptions() {
        if (!this.state.showOptions && this.state.responseData.currentStatus == objectConstants.STATUS_NOT_STARTED) {
            this.setState({showOptions: true});
        }
    }

    onOptionClick(option) {
        let locale_checkedOptions = Object.assign([], this.state.responseData.checkedOptions);
        let optionIndex = appHelper.getArrayObjectIndexByKey(locale_checkedOptions, "option_id", option.option_id);
        if (optionIndex == -1) {
            locale_checkedOptions = dataHelper.immutablePush(locale_checkedOptions, option);
        } else {
            locale_checkedOptions = dataHelper.immutableSplice(locale_checkedOptions, optionIndex, 1);
        }

        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    checkedOptions: dataHelper.immutableSplice(this.state.responseData.checkedOptions, 0, this.state.responseData.checkedOptions.length, option),
                    userSelections: Object.assign([], this.state.responseData.userSelections),
                    initialised: true
                }
            ),
            showFeedback: true,
            showCheckBtn: locale_checkedOptions.length > 0,
            checkAnswers: false,
        });
    }

    //checkedOptions
    checkAnswers() {
        let correctAnswers = appHelper.getTypeCount(this.state.responseData.checkedOptions, "result", "best");
        let incorrectAnswers = appHelper.getNotOfTypeCount(this.state.responseData.checkedOptions, "result", "best");
        let indicators = indicatorHelper.getCheckedOptionIndicators(this.state.responseData.checkedOptions);
        let outcome = {};
        if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"),{
                indicators: indicators
            });
        } else {
            //if (this.state.screenObject.allowPartlyCorrectResponses) {

            if (correctAnswers.length > 0) {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"),{
                    indicators: indicators
                });
                if (!appHelper.isDefined(outcome.result)) {
                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"),{
                        indicators: indicators
                    });
                }
            } else {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"),{
                    indicators: indicators
                });
            }
            /*} else {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result_type", "incorrect"));
            }*/
        }

        if(this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE){
            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"),{
                indicators: indicators,
                result: "reflective"
            });
        }

        let outcomeLocale = appHelper.getLocalData(outcome);

        let firstCheckedOption = {};
        for (let i = 0; i < this.state.screenObject.options.length; i++) {
            let option = this.state.screenObject.options[i];
            let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", option.option_id);
            if (checkedIndex > -1) {
                firstCheckedOption = Object.assign({}, option);
                break;
            }
        }

        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    outcome: outcome,
                    checkedOptions: dataHelper.immutableSplice(this.state.responseData.checkedOptions, 0, this.state.responseData.checkedOptions.length, firstCheckedOption)
                }
            ),
            showFeedback: true,
            questionChecked: true,
            checkAnswers: false,
            outcomeLocale: outcomeLocale
        });
    }

    showFeedback() {
        // console.log("showFeedback");
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
            this.setState({showFeedback: true});
        }
    }

    reattempt() {
        this.setState(
            {
                showFeedback: false,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentAttempt: this.state.responseData.currentAttempt + 1,
                        currentStatus: objectConstants.STATUS_ATTEMPTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
                        outcome: Object.assign({}, {}),
                        checkedOptions: dataHelper.immutableSplice(this.state.responseData.checkedOptions, 0, this.state.responseData.checkedOptions.length)

                    }
                )
            }
        );
    }

    render() {
        return (
            <div className="learner-action">
                {
                    this.state.badgesEarned.length > 0
                        ?
                        <div>
                            {this.state.badgesEarned.map(badge =>
                                <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id} bite_id={this.state.responseData.bite_id} asset_id={this.state.responseData.asset_id} collected={this.state.collected}/>
                            )}
                            <br/>
                        </div>
                        : null
                }

                {this.state.screenObject.prompt_settings.class_name === objectConstants.DIALOG
                    ?
                    <div className="object-container">
                        <DialogPrompt character_name={this.state.character_name}
                                      screenObject={this.state.screenObject}
                                      onComplete={this.renderOptions}
                                      animatePrompt={this.state.animatePrompt}
                                      allowAudioAutoPlay={this.state.allowAudioAutoPlay}/>
                    </div>
                    :
                    <QuestionPrompt screenObject={this.state.screenObject} onComplete={this.renderOptions} animatePrompt={this.state.animatePrompt} allowAudioAutoPlay={this.state.allowAudioAutoPlay}/>
                }

                {
                    this.state.showFeedback && appHelper.isDefined(this.state.outcomeLocale.feedback) && this.state.outcomeLocale.feedback.length > 0
                        ? <MultipleAnswerFeedbackReview options={this.state.screenObject.options}
                                                        key_messages={this.state.screenObject.key_messages}
                                                        asset_id={this.state.screenObject.asset_id}
                                                        responseData={this.state.responseData}
                        />
                        : null
                }

                {this.state.showOptions
                    ?
                    <div className="question-wrapper">
                        <div className="multiple-choice-option-list theme-active">
                            {this.state.screenObject.options.map(option =>
                                <MultipleAnswerOptionReview key={option.option_id} option={option}
                                                            asset_id={this.state.screenObject.asset_id}
                                                            questionChecked={this.state.questionChecked}
                                                            onOptionClick={this.onOptionClick}
                                                            options={this.state.screenObject.options}
                                                            responseData={this.state.responseData}
                                                            index={appHelper.getObjectOptionIndex(this.state.screenObject.options, option.option_id)}
                                                            outcome={this.state.responseData.outcome}
                                />
                            )}
                        </div>
                    </div>
                    : null
                }

            </div>
        );
    }
}

MultipleAnswerReview.propTypes = {
    screenObject: PropTypes.object.isRequired,
    responseData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

MultipleAnswerReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MultipleAnswerReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/multipleAnswer/MultipleAnswerReview.js
 **/